import { Button } from 'rsuite';
import infoIcon from '../../../../../../assets/icons/icon_info.svg';
import styles from './WarningProductsOutOfList.module.scss';

type WarningProductsOutOfListProps = {
  onShowModal: () => void;
  content: React.ReactNode;
  style?: React.CSSProperties;
};

export const WarningProductsOutOfList = ({ content, style, onShowModal }: WarningProductsOutOfListProps) => (
  <div className={styles['warning-detalhes-produtos']} style={style}>
    <img src={infoIcon} alt="Informação sobre produtos fora do contrato" />
    {content}
    <span>
      <Button className={styles['link-btn']} appearance="link" onClick={onShowModal}>
        Ver lista de produtos
      </Button>
    </span>
  </div>
);
